// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import PropertiesPlugin from "./PropertiesPlugin";
import { TelemetryTrace } from "./Context/TelemetryTrace";
import { TelemetryContext } from './TelemetryContext';
import { Session, _SessionManager } from "./Context/Session";
export { PropertiesPlugin, TelemetryTrace, TelemetryContext, Session, _SessionManager as SessionManager };
//# sourceMappingURL=applicationinsights-properties-js.js.map